export const medication_filter = [
  {
    label: 'All',
    value: 1,
  }, {
    label: 'Active',
    value: 2,
  },
]
